// The distinct-respondent key for a dialog node's metadata, in
// identity-precedence order: invited respondents key on their email; anonymous
// (shared-link) submissions key on their per-session actor id so two different
// anonymous people don't collapse into one; the display name is the last
// resort, so legacy rows that predate respondentActorId still collapse un-named
// anonymous onto 'Anonymous'.
//
// Deliberate twin of deriveRespondentKey in lambda/shared/synthesis-ai.ts — the
// frontend tsconfig includes only `src`, so the lambda copy can't be imported.
// They must agree: if the canvas grouped respondents differently from the way
// synthesis counts them, "N of M respondents" and the graph would disagree.
//
// Distinct from the *display* precedence in BaseNode/NodeDetailsModal, which
// prefers the human-readable name. This is an identity key, so it prefers the
// stable one.
export function deriveRespondentKey(meta: Record<string, unknown>): string | undefined {
  return (
    (typeof meta.respondentEmail === 'string' && meta.respondentEmail) ||
    (typeof meta.respondentActorId === 'string' && meta.respondentActorId) ||
    (typeof meta.respondentName === 'string' && meta.respondentName) ||
    undefined
  );
}
